/**
 * The text a result card shows for a run of fields, joined in the order asked for and separated
 * by commas unless `noCommas` - names read as "Ada Lovelace", addresses as "London, England".
 * A field with no value is left out, and when the last one is missing the comma trailing the
 * field before it goes with it.
 */
export function getText(fieldNames: string[], base: unknown, noCommas: boolean = false): string {
  let text: string = "";

  for (let index = 0; index < fieldNames.length; index++) {
    const value = fieldNames[index];
    const isLastLoop: boolean = index === fieldNames.length - 1;
    const comma: string = noCommas || isLastLoop ? "" : ",";

    // If value is invalid, and we're on the last iteration then remove the last comma
    if (!base?.[value as keyof unknown] && isLastLoop) text = text.slice(0, -1);

    // Value is invalid, skip
    if (!base?.[value as keyof unknown]) continue;

    text += ` ${base?.[value as keyof unknown]}${comma}`;
  }

  return text.trim();
}
